import { useState, useEffect } from 'react';
import { makeStyles } from 'tss-react/mui';
import { CardMedia, Dialog, DialogTitle, DialogActions, Button, DialogContent, Link, Grid } from '@mui/material';
import axios from 'axios';

interface IMediaThumb {
    mediaId: string
    extension: string
    isImage: boolean
    isVideo: boolean
    openInGallery?: boolean
}

const useStyles = makeStyles()(() => ({
    card: {
        color: 'transparent',
        '&:hover': {
            boxShadow: ' 0 7px 20px rgba(0,0,0,0.15), 0 8px 10px rgba(0,0,0,0.2), 0 6px 3px -4px rgba(0,0,0,0.15)'
        }
    },
    image: {
        margin: 'auto'
    },
    video: {
        width: '100%',
        height: 'auto',
        maxHeight: '100%'
    },
    videoContent: {
        height: '100vh'
    }
}));

let MediaThumb = (props: IMediaThumb) => {
    let { classes } = useStyles();

    let [thumbnail, setThumbnail] = useState('');
    let [imageDetail, setImageDetail] = useState(`/images/fileTypes/${props.extension.toLowerCase()}.svg`);
    let [showPreview, setShowPreview] = useState(false);


    useEffect(() => {
        let prepareData = () => {
            setThumbnail(`/api/TicketMessage/GetTicketMedia?mediaId=${props.mediaId}&width=150&height=150`);

            if (props.isVideo === true)
                prepareVideoData();
            else
                prepareImageData();

        }

        if (props.isImage === true || props.isVideo === true)
            prepareData();

    }, [props.mediaId, props.isImage, props.isVideo])


    let prepareImageData = () => {
        setThumbnail(`/api/TicketMessage/GetTicketMedia?mediaId=${props.mediaId}&width=150&height=150`);
        setImageDetail(`/api/TicketMessage/GetTicketMedia?mediaId=${props.mediaId}&width=1200&height=1200`);
    }

    let prepareVideoData = async () => {
        setThumbnail(`/api/TicketMessage/GetTicketMedia?mediaId=${props.mediaId}&width=150&height=150`);

        try {
            let res = await axios.get('/api/TicketMessage/GetTicketMediaUrl', { params: { mediaId: props.mediaId } });
            setImageDetail(res.data);
        } catch (err) { }
    }


    return (
        <>
            <CardMedia
                className={classes.card}
                image={thumbnail}
                component="img"
                onClick={() => setShowPreview(true)}
                style={{
                    cursor: 'pointer',
                    minWidth: 150,
                    minHeight: 150,
                    maxWidth: 150
                }}
            />
            {props.openInGallery === true &&
                <Link id={`${props.mediaId}_gallery-open`} target="_blank" href={`${process.env.REACT_APP_GALLERY_URL}/media/detail/${props.mediaId}`}>
                    Apri in Gallery
                </Link>
            }

            <Dialog
                open={showPreview}
                maxWidth="lg"
                fullWidth={true}
                scroll="paper"
                onClose={() => setShowPreview(false)}
            >
                <DialogTitle />


                {props.isVideo === true &&
                    <DialogContent className={classes.videoContent}>
                        <video className={classes.video} controls autoPlay controlsList="nodownload">
                            <source src={imageDetail} type="video/mp4" />
                            Your browser does not support HTML video.
                        </video>
                    </DialogContent>
                }

                {props.isImage === true &&
                    <DialogContent>
                        <CardMedia
                            image={imageDetail}
                            component="img"
                            className={classes.image}
                        />
                    </DialogContent>
                }

                <DialogActions>
                    <Button
                        onClick={() => setShowPreview(false)}
                        color="secondary"
                    >
                        Chiudi
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default MediaThumb;